export class Section {
    ID?: number;
    Name?: string;
    FriendlyName?: string;
}

export default Section;